import { I18nText, ProductSection } from "@/api/product-api";

// I18nText에서 현재 locale에 맞는 텍스트를 가져옵니다
export const getLocalizedText = (
  i18nText: I18nText | undefined,
  locale: string,
  fallback?: string,
): string => {
  if (!i18nText) return "";

  // Next.js locale은 "ko"를 사용 (ISO 639-1 표준)
  // I18nText에 정의된 언어인지 확인 후 사용
  const supportedLocales: (keyof I18nText)[] = [
    "en",
    "ko",
    "ja",
    "fr",
    "es",
    "de",
    "zh",
  ];
  const localeKey = supportedLocales.includes(locale as keyof I18nText)
    ? (locale as keyof I18nText)
    : "en";

  // 해당 locale 값이 있으면 반환, 없으면 fallback -> 영어로 fallback
  return i18nText[localeKey] || fallback || i18nText.en || "";
};

// 제품 섹션 컴포넌트
export const ProductSections = ({
  productSectionTitle,
  productSections,
  locale,
}: {
  productSectionTitle?: I18nText;
  productSections?: ProductSection[];
  locale: string;
}) => {
  const sectionTitle = getLocalizedText(productSectionTitle, locale).trim();

  if (!productSections || productSections.length === 0) {
    return null;
  }

  // 실제 표시할 내용이 있는 섹션만 필터링
  const validSections = productSections
    .map((section) => {
      const title = getLocalizedText(section.title, locale).trim();
      const items = section.items
        .map((item) => getLocalizedText(item, locale).trim())
        .filter((text) => text.length > 0);

      return { title, items };
    })
    .filter((section) => section.title.length > 0 || section.items.length > 0);

  // 섹션 타이틀도 없고 유효한 섹션도 없으면 렌더링하지 않음
  if (!sectionTitle && validSections.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col">
      {sectionTitle && (
        <h2 className="mb-6 text-2xl font-600">{sectionTitle}</h2>
      )}

      {validSections.map((section, index) => (
        <div key={index} className="mb-6 flex flex-col gap-5 last:mb-0">
          {section.title && (
            <h3 className="text-2xl font-400">{section.title}</h3>
          )}
          {section.items.length > 0 && (
            <ul className="list-disc pl-6 text-lg tracking-[0.5px]">
              {section.items.map((item, itemIndex) => (
                <li key={itemIndex}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};
